import intl from 'react-intl-universal';

export const getSupplierCodeFormated = (codigoFornecedorMdg, CodigoSapFornecedor, HasAuroraBusinessUnities) => {
  return HasAuroraBusinessUnities
    ? `${codigoFornecedorMdg} (${intl.get("master-data.general-configuration.legacy")}: ${parseInt(CodigoSapFornecedor)})`
    : CodigoSapFornecedor;
};
